import { VFC } from "react";
import { Box, Grid } from "@mui/material";
import { ContractDetailResponse } from "../../contract/api/ContractForm";
import { Utility } from "../../../utils/Utility";

type Props = {
  contract: ContractDetailResponse;
};
const ContractDetailView: VFC<Props> = ({ contract: contract }) => {

  const CELL_WIDTH = 3;

  const style = {
    gridWrap: {
      fontSize: "0.875rem",
      mb: 2,
      "& > div": {
        p: 1,
      },
      "& > div:not(:nth-of-type(4n))": {
        borderRight: "1px solid #eaeded",
      },
      "& div div:nth-of-type(1)": {
        color: "#545b64",
      },
      "& div div:nth-of-type(2)": {
        color: "#16191f",
        fontWeight: "bold",
      },
    },
  };

  return (
    <Box display={"flex"} flexWrap={"wrap"} sx={style.gridWrap}>
      <Grid item xs={CELL_WIDTH}>
        <Box>契約ID</Box>
        <Box>{Utility.NullEmptyStringWrap(contract.id)}</Box>
      </Grid>
      <Grid item xs={CELL_WIDTH}>
        <Box>契約コード</Box>
        <Box>{Utility.NullEmptyStringWrap(contract.disclosureCode)}</Box>
      </Grid>
      <Grid item xs={CELL_WIDTH}>
        <Box>テナント名</Box>
        <Box>{Utility.NullEmptyStringWrap(contract.tenantName)}</Box>
      </Grid>
      <Grid item xs={CELL_WIDTH}>
        <Box>企業名</Box>
        <Box>{Utility.NullEmptyStringWrap(contract.companyName)}</Box>
      </Grid>
      {/* <Grid item xs={CELL_WIDTH}>
        <Box>組織名</Box>
        <Box>{Utility.NullEmptyStringWrap(contract.organizationName)}</Box>
      </Grid> */}
      <Grid item xs={CELL_WIDTH}>
        <Box>契約期間</Box>
        <Box>{Utility.NullEmptyStringWrap(Utility.dateFormat(contract.contractStart))}~{Utility.NullEmptyStringWrap(Utility.dateFormat(contract.contractEnd))}</Box>
      </Grid>
      <Grid item xs={CELL_WIDTH}>
        <Box>契約台数</Box>
        <Box>{Utility.NullEmptyStringWrap(contract.contractDevice)}</Box>
      </Grid>
      <Grid item xs={CELL_WIDTH}>
        <Box>契約人数</Box>
        <Box>{Utility.NullEmptyStringWrap(contract.contractPeople)}</Box>
      </Grid>
      <Grid item xs={CELL_WIDTH}>
        <Box>契約ステータス</Box>
        <Box>{Utility.NullEmptyStringWrap(contract.status)}</Box>
      </Grid>
      <Grid item xs={CELL_WIDTH}>
        <Box>トライアル</Box>
        <Box>{Utility.NullEmptyStringWrap(contract.trial)}</Box>
      </Grid>
      <Grid item xs={CELL_WIDTH}>
        <Box>端末登録料</Box>
        <Box>{Utility.NullEmptyStringWrap(contract.entryPrice)}</Box>
      </Grid>
      <Grid item xs={CELL_WIDTH}>
        <Box>月額利用料</Box>
        <Box>{Utility.NullEmptyStringWrap(contract.contractPrice)}</Box>
      </Grid>
      <Grid item xs={CELL_WIDTH}>
        <Box>お客様管理者氏名1</Box>
        <Box>{Utility.NullEmptyStringWrap(contract.adminUserName1)}</Box>
      </Grid>
      <Grid item xs={CELL_WIDTH}>
        <Box>お客様管理者氏名2</Box>
        <Box>{Utility.NullEmptyStringWrap(contract.adminUserName2)}</Box>
      </Grid>
      <Grid item xs={CELL_WIDTH}>
        <Box>営業担当者名</Box>
        <Box>{Utility.NullEmptyStringWrap(contract.salesStaffName)}</Box>
      </Grid>
      <Grid item xs={CELL_WIDTH}>
        <Box>備考1</Box>
        <Box>{Utility.NullEmptyStringWrap(contract.comment1)}</Box>
      </Grid>
      <Grid item xs={CELL_WIDTH}>
        <Box>備考2</Box>
        <Box>{Utility.NullEmptyStringWrap(contract.comment2)}</Box>
      </Grid>
      <Grid item xs={CELL_WIDTH}>
        <Box>作成者</Box>
        <Box>{contract.createUser}</Box>
      </Grid>
      <Grid item xs={CELL_WIDTH}>
        <Box>作成日時</Box>
        <Box>{Utility.NullEmptyStringWrap(Utility.dateFormat(contract.createDate))}</Box>
      </Grid>
      <Grid item xs={CELL_WIDTH}>
        <Box>更新者</Box>
        <Box>{Utility.NullEmptyStringWrap(contract.updateUser)}</Box>
      </Grid>
      <Grid item xs={CELL_WIDTH}>
        <Box>更新日時</Box>
        <Box>{Utility.NullEmptyStringWrap(Utility.dateFormat(contract.updateDate))}</Box>
      </Grid>
      <Grid item xs={CELL_WIDTH}>
        <Box>削除日時</Box>
        <Box>{Utility.NullEmptyStringWrap(Utility.dateFormat(contract.deleteDate))}</Box>
      </Grid>
    </Box>
  );

};

export default ContractDetailView;
